import React from 'react';
import 'rc-dialog/assets/bootstrap.css';
import SelectCommonDefault from '../Common/SelectCommonDefault';


class Facturacion extends React.Component {

    constructor( props ) {
        super( props );
        this.state = {
        };
    }

    handleChangeLimiteFinanciacion(e) {
        this.setState({ limiteFinanciacion: e.target.value });
        this.props.onBlurTextBox("limiteFinanciacion", e.target.value);
    }

    componentDidUpdate(props) {
        const { data, tarjetas } = props;
        
        //SI SE TRATA DE UNA MODIFICACIÓN CARGO LOS DATOS CORRESPONDIENTES
        if (!this.props.tarjetas.vuelveDeAdicional && tarjetas.solicitudCuenta.GET_PRODUCTO_VISA_PRODUCTO_ID && tarjetas.solicitudCuenta.GET_PRODUCTO_VISA_PRODUCTO_ID.Id && tarjetas.esModificacion && !data.facturacionModificacion) {
           let limFin = tarjetas.datosSolicitud.LimiteFinanciacion;
            
           if(limFin){
            this.setState({ limiteFinanciacion:limFin });
            this.props.onBlurTextBox("limiteFinanciacion", limFin);
           }

           //UNA VEZ CARGADOS LOS DATOS PASO A TRUE EL FLAG QUE LO INDICA
           if(limFin && data.limiteFinanciacion == limFin) this.props.cargarDatosModificacion("facturacionModificacion")
           
        }
    } 

    render() {
        
        const { tipoEmpresa, selectCombo, data, tarjetas } = this.props;
        const { GET_PRODUCTO_DEFAULT_VISA_PRODUCTO } = data;
        let modelosLiquidacion = data.GET_MODELO_LIQUIDACION_PRODUCTO.map((modeloLiquidacion) => { return {Id: modeloLiquidacion.ID, Descripcion: modeloLiquidacion.CODIGO + ' - ' + modeloLiquidacion.DESCRIPCION}});
        let parametrosGenerales = data.GET_ATLAS_PARAMETRO_GENERAL;
        let productoVisa = data.GET_PRODUCTO_VISA_PRODUCTO_ID;
        let categoriaCajeros = data.GET_ATLAS_CATEGORIA_CAJERO_PRODUCTO.map((categoriaCajero) => { return { Id: categoriaCajero.ID, Descripcion: categoriaCajero.CODIGO + ' - ' + categoriaCajero.DESCRIPCION } });
        let carteras = [];
        let valoresDefault = !tarjetas.esModificacion ? GET_PRODUCTO_DEFAULT_VISA_PRODUCTO : tarjetas.datosSolicitud;

        if (tipoEmpresa) {

            if (tipoEmpresa.EmpresaIndividuos == 'I' && Array.isArray(data.GET_CARTERAS_PRODUCTO)){
                carteras = data.GET_CARTERAS_PRODUCTO.map((cartera) => { return { Id: cartera.Id, Descripcion: cartera.Codigo + ' - ' + cartera.Descripcion } });
            }
            else if (tipoEmpresa.EmpresaIndividuos == 'E' && Array.isArray(data.GET_CARTERAS_EMPRESA)){
                //si la empresa fue creada en la misma solicitud,la cartera se obtiene del objeto "cartera"
                let carteraEmpresa = tarjetas.empresaVisaSeleccionada.CarteraId ? tarjetas.empresaVisaSeleccionada.CarteraId : tarjetas.empresaVisaSeleccionada.cartera.id

                carteras = data.GET_CARTERAS_EMPRESA.filter(cartera=>cartera.Id== carteraEmpresa && cartera.AdministradoraId == 1);
                carteras = carteras.map((cartera) => { return { Id: cartera.Id, Descripcion: cartera.Codigo + ' - ' + cartera.Descripcion } });
            }
        }

        let errorLimiteFinanciacion
        if(data.limiteFinanciacion && productoVisa){
            errorLimiteFinanciacion = !(data.limiteFinanciacion>=productoVisa.LimiteFinanciacionDesde && data.limiteFinanciacion<= productoVisa.LimiteFinanciacionHasta)
        } 
        
        return (
            <div className="row">
                <div className="facturacion col-md-12">
                    <div className="divisor-section bottom-separator" >
                        <h2>Facturación </h2>
                    </div>
                    <div className="facturacion-body">
                        <div className="form-group bottom-separator-xs">
                            <label className="label-primary">
                                Cartera
                            </label>
                            <SelectCommonDefault esModificacion={this.props.tarjetas.solicitudCuenta.esModificacion} infoData={carteras} valorCombo={valoresDefault["CarteraDefaultId"] ? valoresDefault["CarteraDefaultId"] : valoresDefault["CarteraId"]} selectCombo={selectCombo} nombreAction={"carteraId"} selecciones={data}/>

                            {(!data.ERROR_CUENTA["carteraId"])
                                && <label className="error">{"Debe seleccionar una cartera."}</label>}

                        </div>

                        <div className="form-group bottom-separator-xs">
                            <label className="label-primary">
                                Modelo de Liquidación
                            </label>
                            <SelectCommonDefault esModificacion={this.props.tarjetas.solicitudCuenta.esModificacion} infoData={modelosLiquidacion} valorCombo={valoresDefault["ModeloLiquidacionDefaultId"] ? valoresDefault["ModeloLiquidacionDefaultId"] : valoresDefault["ModeloLiquidacionId"]} selectCombo={selectCombo} nombreAction={"modeloLiquidacionId"} selecciones={data} />

                            {(!data.ERROR_CUENTA["modeloLiquidacionId"])
                                && <label className="error">{"Debe seleccionar un modelo de liquidación."}</label>}

                        </div>

                        {(parametrosGenerales.SINOLIMITEFINANCIACIONCUENTA && productoVisa && productoVisa.LimiteFinanciacionxCuenta) ?
                            (<div className="form-group bottom-separator-xs">
                                <label className="label-primary">
                                    Limite de Financiación
                            </label>
                                <div >
                                    <label className="label-secondary"> Limite de Financiación </label>
                                    <input className="input-facturacion" type="text" maxLength="2" value={tarjetas.solicitudCuenta.limiteFinanciacion} onChange={this.handleChangeLimiteFinanciacion.bind(this)} />
                                    <label className="label-secondary">% (entre {productoVisa.LimiteFinanciacionDesde}% y {productoVisa.LimiteFinanciacionHasta}%)</label>
                                </div>

                                {(!data.ERROR_CUENTA["limiteFinanciacion"] && errorLimiteFinanciacion)
                                    && <label className="error">{"El Limite de Financiación debe estar dentro del rango definido por el producto."}</label>}
                                {(!data.ERROR_CUENTA["limiteFinanciacion"] && !errorLimiteFinanciacion)
                                    && <label className="error">{"Debe ingresar un limite de financiación."}</label>}

                            </div>) : null}

                        {parametrosGenerales.SINOREDBANELCO ?
                            (<div className="form-group bottom-separator-xs">
                                <label className="label-primary">
                                    Categoria de Cajeros
                            </label>
                                <SelectCommonDefault esModificacion={this.props.tarjetas.solicitudCuenta.esModificacion} infoData={categoriaCajeros} valorCombo={valoresDefault["CategoriaCajeroDefaultId"] ? valoresDefault["CategoriaCajeroDefaultId"] : valoresDefault["CategoriaCajeroVisaId"]} selectCombo={selectCombo} nombreAction={"categoriaCajerosId"} selecciones={data} />

                                {(!data.ERROR_CUENTA["categoriaCajerosId"])
                                    && <label className="error">{"Debe seleccionar una categoría de cajeros."}</label>}

                            </div>) : null}
                    </div>
                </div>
            </div>

        )
    }
}

export default Facturacion;